// Extended pricing data for all brands and services

export const applePrices = {
  screen: [
    { model: "iPhone 16 Pro Max", price: "4999 kr", time: "30 Min" },
    { model: "iPhone 16 Pro", price: "4500 kr", time: "30 Min" },
    { model: "iPhone 16 Plus", price: "3200 kr", time: "30 Min" },
    { model: "iPhone 16", price: "3000 kr", time: "30 Min" },
    { model: "iPhone 15 Pro Max", price: "4899 kr", time: "30 Min" },
    { model: "iPhone 15 Pro", price: "3899 kr", time: "30 Min" },
    { model: "iPhone 15 Plus", price: "2800 kr", time: "30 Min" },
    { model: "iPhone 15", price: "2600 kr", time: "30 Min" },
    { model: "iPhone 14 Pro Max", price: "3699 kr", time: "30 Min" },
    { model: "iPhone 14 Pro", price: "2899 kr", time: "30 Min" },
    { model: "iPhone 14 Plus", price: "2500 kr", time: "30 Min" },
    { model: "iPhone 14", price: "2300 kr", time: "30 Min" },
    { model: "iPhone 13 Pro Max", price: "2799 kr", time: "30 Min" },
    { model: "iPhone 13 Pro", price: "2300 kr", time: "30 Min" },
    { model: "iPhone 13", price: "1800 kr", time: "30 Min" },
    { model: "iPhone 13 Mini", price: "1900 kr", time: "30 Min" },
    { model: "iPhone 12 Pro Max", price: "2200 kr", time: "30 Min" },
    { model: "iPhone 12 Pro", price: "2000 kr", time: "30 Min" },
    { model: "iPhone 12", price: "1800 kr", time: "30 Min" },
    { model: "iPhone 12 Mini", price: "1600 kr", time: "30 Min" },
    { model: "iPhone 11 Pro Max", price: "1499 kr", time: "30 Min" },
    { model: "iPhone 11 Pro", price: "1199 kr", time: "30 Min" },
    { model: "iPhone 11", price: "1199 kr", time: "30 Min" },
    { model: "iPhone XS Max", price: "1399 kr", time: "30 Min" },
    { model: "iPhone XS", price: "1199 kr", time: "30 Min" },
    { model: "iPhone XR", price: "1199 kr", time: "30 Min" },
    { model: "iPhone X", price: "1199 kr", time: "30 Min" },
    { model: "iPhone 8 Plus", price: "899 kr", time: "30 Min" },
    { model: "iPhone 8", price: "799 kr", time: "30 Min" },
    { model: "iPhone 7 Plus", price: "899 kr", time: "30 Min" },
    { model: "iPhone 7", price: "699 kr", time: "30 Min" },
    { model: "iPhone SE (2020/2022)", price: "899 kr", time: "30 Min" },
    { model: "iPhone 6S Plus", price: "699 kr", time: "30 Min" },
    { model: "iPhone 6S", price: "499 kr", time: "30 Min" }
  ],
  battery: [
    { model: "iPhone 16 Pro Max", price: "1899 kr", time: "30 Min" },
    { model: "iPhone 16 Pro", price: "1499 kr", time: "30 Min" },
    { model: "iPhone 16 Plus", price: "1099 kr", time: "30 Min" },
    { model: "iPhone 16", price: "999 kr", time: "30 Min" },
    { model: "iPhone 15 Pro Max", price: "1899 kr", time: "30 Min" },
    { model: "iPhone 15 Pro", price: "1499 kr", time: "30 Min" },
    { model: "iPhone 15 Plus", price: "1099 kr", time: "30 Min" },
    { model: "iPhone 15", price: "999 kr", time: "30 Min" },
    { model: "iPhone 14 Pro Max", price: "1899 kr", time: "30 Min" },
    { model: "iPhone 14 Pro", price: "1499 kr", time: "30 Min" },
    { model: "iPhone 14 Plus", price: "1099 kr", time: "30 Min" },
    { model: "iPhone 14", price: "999 kr", time: "30 Min" },
    { model: "iPhone 13 Pro Max", price: "1299 kr", time: "30 Min" },
    { model: "iPhone 13 Pro", price: "1299 kr", time: "30 Min" },
    { model: "iPhone 13", price: "1099 kr", time: "30 Min" },
    { model: "iPhone 12 Pro Max", price: "1099 kr", time: "30 Min" },
    { model: "iPhone 12 Pro", price: "1099 kr", time: "30 Min" },
    { model: "iPhone 12", price: "999 kr", time: "30 Min" },
    { model: "iPhone 11 Pro Max", price: "799 kr", time: "30 Min" },
    { model: "iPhone 11 Pro", price: "799 kr", time: "30 Min" },
    { model: "iPhone 11", price: "799 kr", time: "30 Min" },
    { model: "iPhone X/XS/XR", price: "699 kr", time: "30 Min" },
    { model: "iPhone XS Max", price: "799 kr", time: "30 Min" },
    { model: "iPhone 8 Plus", price: "499 kr", time: "30 Min" },
    { model: "iPhone 8", price: "499 kr", time: "30 Min" },
    { model: "iPhone 7 Plus", price: "499 kr", time: "30 Min" },
    { model: "iPhone 7", price: "499 kr", time: "30 Min" },
    { model: "iPhone SE", price: "599 kr", time: "30 Min" },
    { model: "iPhone 6S Plus", price: "499 kr", time: "30 Min" },
    { model: "iPhone 6S", price: "399 kr", time: "30 Min" }
  ],
  chargingPort: [
    { model: "iPhone 15/15 Pro/15 Pro Max", price: "1499 kr", time: "60 Min" },
    { model: "iPhone 14/14 Pro/14 Pro Max", price: "1399 kr", time: "60 Min" },
    { model: "iPhone 13/13 Pro/13 Pro Max", price: "1299 kr", time: "60 Min" },
    { model: "iPhone 12/12 Pro/12 Pro Max", price: "1199 kr", time: "60 Min" },
    { model: "iPhone 11/11 Pro/11 Pro Max", price: "999 kr", time: "60 Min" },
    { model: "iPhone 8/8 Plus/SE", price: "999 kr", time: "60 Min" },
    { model: "iPhone X/XS/XR/XS Max", price: "899 kr", time: "60 Min" },
    { model: "iPhone 7/7 Plus", price: "699 kr", time: "60 Min" },
    { model: "iPhone 6S/6S Plus", price: "599 kr", time: "60 Min" }
  ],
  speaker: [
    { model: "iPhone 15/15 Pro", price: "1199 kr", time: "45 Min" },
    { model: "iPhone 14/14 Pro", price: "1099 kr", time: "45 Min" },
    { model: "iPhone 13/13 Pro", price: "999 kr", time: "45 Min" },
    { model: "iPhone 12/12 Pro", price: "899 kr", time: "45 Min" },
    { model: "iPhone 11/11 Pro/11 Pro Max", price: "799 kr", time: "45 Min" },
    { model: "iPhone 8/8 Plus", price: "599 kr", time: "45 Min" },
    { model: "iPhone X/XS/XR", price: "699 kr", time: "45 Min" },
    { model: "iPhone 7/7 Plus", price: "549 kr", time: "45 Min" },
    { model: "iPhone 6/6S", price: "499 kr", time: "45 Min" }
  ],
  camera: [
    { model: "iPhone 15 Pro Max (Bak)", price: "1799 kr", time: "45 Min" },
    { model: "iPhone 15 Pro (Bak)", price: "1699 kr", time: "45 Min" },
    { model: "iPhone 14 Pro Max (Bak)", price: "1599 kr", time: "45 Min" },
    { model: "iPhone 14 Pro (Bak)", price: "1499 kr", time: "45 Min" },
    { model: "iPhone 13 Pro Max (Bak)", price: "1399 kr", time: "45 Min" },
    { model: "iPhone 13 Pro (Bak)", price: "1299 kr", time: "45 Min" },
    { model: "iPhone 12 Pro Max (Bak)", price: "1199 kr", time: "45 Min" },
    { model: "iPhone 12 Pro (Bak)", price: "1099 kr", time: "45 Min" },
    { model: "iPhone 11 Pro Max (Bak)", price: "999 kr", time: "45 Min" },
    { model: "iPhone 11 Pro (Bak)", price: "899 kr", time: "45 Min" },
    { model: "iPhone 11 (Bak)", price: "699 kr", time: "45 Min" },
    { model: "iPhone X/XS/XR (Bak)", price: "799 kr", time: "45 Min" },
    { model: "iPhone 8/8 Plus (Bak)", price: "599 kr", time: "45 Min" },
    { model: "iPhone 7/7 Plus (Front)", price: "549 kr", time: "30 Min" },
    { model: "iPhone 11/11 Pro (Front)", price: "999 kr", time: "30 Min" },
    { model: "iPhone 12/12 Pro (Front)", price: "1199 kr", time: "30 Min" }
  ]
};

export const samsungPrices = {
  screen: [
    { model: "Samsung Galaxy S24 Ultra", price: "5500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S24 Plus", price: "3500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S24", price: "3500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S23 Ultra", price: "5500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S23 Plus", price: "3500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S23", price: "3500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S22 Ultra", price: "5500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S22 Plus", price: "3500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S22", price: "3500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S21 Ultra", price: "5500 kr", time: "60 Min" },
    { model: "Samsung Galaxy S21 Plus", price: "2000 kr", time: "60 Min" }
  ],
  battery: [
    { model: "Samsung Galaxy S24 Ultra", price: "799 kr", time: "45 Min" },
    { model: "Samsung Galaxy S24/S24 Plus", price: "749 kr", time: "45 Min" },
    { model: "Samsung Galaxy S23 Ultra", price: "749 kr", time: "45 Min" },
    { model: "Samsung Galaxy S23/S23 Plus", price: "699 kr", time: "45 Min" },
    { model: "Samsung Galaxy S22 Ultra", price: "699 kr", time: "45 Min" },
    { model: "Samsung Galaxy S22/S22 Plus", price: "649 kr", time: "45 Min" },
    { model: "Samsung Galaxy S21 Ultra", price: "649 kr", time: "45 Min" },
    { model: "Samsung Galaxy S21/S21 Plus", price: "599 kr", time: "45 Min" },
    { model: "Samsung Galaxy S20 Ultra", price: "599 kr", time: "45 Min" },
    { model: "Samsung Galaxy S20/S20 Plus", price: "549 kr", time: "45 Min" },
    { model: "Samsung Galaxy S10/S10 Plus", price: "549 kr", time: "45 Min" },
    { model: "Samsung Galaxy A54", price: "599 kr", time: "45 Min" },
    { model: "Samsung Galaxy A53", price: "549 kr", time: "45 Min" },
    { model: "Samsung Galaxy A52", price: "499 kr", time: "45 Min" },
    { model: "Samsung Galaxy A34", price: "549 kr", time: "45 Min" },
    { model: "Samsung Galaxy A33", price: "499 kr", time: "45 Min" }
  ],
  chargingPort: [
    { model: "Samsung Galaxy S24 serien", price: "899 kr", time: "60 Min" },
    { model: "Samsung Galaxy S23 serien", price: "849 kr", time: "60 Min" },
    { model: "Samsung Galaxy S22 serien", price: "799 kr", time: "60 Min" },
    { model: "Samsung Galaxy S21 serien", price: "749 kr", time: "60 Min" },
    { model: "Samsung Galaxy S20 serien", price: "699 kr", time: "60 Min" },
    { model: "Samsung Galaxy A serien", price: "649 kr", time: "60 Min" }
  ],
  camera: [
    { model: "Samsung Galaxy S24 Ultra (Bak)", price: "1299 kr", time: "45 Min" },
    { model: "Samsung Galaxy S23 Ultra (Bak)", price: "1199 kr", time: "45 Min" },
    { model: "Samsung Galaxy S22 Ultra (Bak)", price: "1099 kr", time: "45 Min" },
    { model: "Samsung Galaxy S21 Ultra (Bak)", price: "999 kr", time: "45 Min" },
    { model: "Samsung Galaxy S20/S21 (Bak)", price: "799 kr", time: "45 Min" },
    { model: "Samsung Galaxy A serien (Bak)", price: "699 kr", time: "45 Min" }
  ]
};

export const huaweiPrices = {
  screen: [
    { model: "Huawei P60 Pro", price: "2500 kr", time: "60 Min" },
    { model: "Huawei P50 Pro", price: "2200 kr", time: "60 Min" },
    { model: "Huawei P40 Pro", price: "1900 kr", time: "60 Min" },
    { model: "Huawei P30 Pro", price: "1600 kr", time: "60 Min" },
    { model: "Huawei P30", price: "1400 kr", time: "60 Min" },
    { model: "Huawei P20 Pro", price: "1300 kr", time: "60 Min" },
    { model: "Huawei P20", price: "1100 kr", time: "60 Min" },
    { model: "Huawei Mate 50 Pro", price: "2400 kr", time: "60 Min" },
    { model: "Huawei Mate 40 Pro", price: "2100 kr", time: "60 Min" },
    { model: "Huawei Mate 30 Pro", price: "1800 kr", time: "60 Min" },
    { model: "Huawei Mate 20 Pro", price: "1500 kr", time: "60 Min" }
  ],
  battery: [
    { model: "Huawei P60 Pro", price: "699 kr", time: "45 Min" },
    { model: "Huawei P50 Pro", price: "649 kr", time: "45 Min" },
    { model: "Huawei P40 Pro", price: "599 kr", time: "45 Min" },
    { model: "Huawei P30 Pro", price: "549 kr", time: "45 Min" },
    { model: "Huawei P30", price: "499 kr", time: "45 Min" },
    { model: "Huawei P20 Pro", price: "499 kr", time: "45 Min" },
    { model: "Huawei Mate 50 Pro", price: "699 kr", time: "45 Min" },
    { model: "Huawei Mate 40 Pro", price: "649 kr", time: "45 Min" },
    { model: "Huawei Mate 30 Pro", price: "599 kr", time: "45 Min" },
    { model: "Huawei Mate 20 Pro", price: "549 kr", time: "45 Min" }
  ],
  chargingPort: [
    { model: "Huawei P serien", price: "799 kr", time: "60 Min" },
    { model: "Huawei Mate serien", price: "849 kr", time: "60 Min" }
  ],
  camera: [
    { model: "Huawei P60/P50 Pro (Bak)", price: "999 kr", time: "45 Min" },
    { model: "Huawei P40/P30 Pro (Bak)", price: "799 kr", time: "45 Min" },
    { model: "Huawei Mate serien (Bak)", price: "899 kr", time: "45 Min" }
  ]
};

export const pcPrices = {
  screen: [
    { model: "MacBook Pro 16\" (M3/M2/M1)", price: "Fra 6500 kr", time: "2-3 dager" },
    { model: "MacBook Pro 14\" (M3/M2/M1)", price: "Fra 5500 kr", time: "2-3 dager" },
    { model: "MacBook Air 15\" (M2)", price: "Fra 5000 kr", time: "2-3 dager" },
    { model: "MacBook Air 13\" (M2/M1)", price: "Fra 4500 kr", time: "2-3 dager" },
    { model: "MacBook Pro 13\" (Intel)", price: "Fra 4000 kr", time: "2-3 dager" },
    { model: "Laptop 17\"", price: "Fra 3500 kr", time: "2-3 dager" },
    { model: "Laptop 15.6\"", price: "Fra 2800 kr", time: "2-3 dager" },
    { model: "Laptop 14\"", price: "Fra 2500 kr", time: "2-3 dager" },
    { model: "Laptop 13.3\"", price: "Fra 2200 kr", time: "2-3 dager" }
  ],
  keyboard: [
    { model: "MacBook Pro/Air", price: "Fra 2500 kr", time: "1-2 dager" },
    { model: "Laptop (Standard)", price: "Fra 1500 kr", time: "1-2 dager" },
    { model: "Gaming Laptop", price: "Fra 1800 kr", time: "1-2 dager" }
  ],
  storage: [
    { model: "SSD 256GB oppgradering", price: "Fra 1200 kr", time: "1 dag" },
    { model: "SSD 512GB oppgradering", price: "Fra 1800 kr", time: "1 dag" },
    { model: "SSD 1TB oppgradering", price: "Fra 2500 kr", time: "1 dag" },
    { model: "SSD 2TB oppgradering", price: "Fra 4500 kr", time: "1 dag" },
    { model: "HDD til SSD konvertering", price: "Fra 1500 kr", time: "1 dag" }
  ],
  ram: [
    { model: "8GB RAM oppgradering", price: "Fra 800 kr", time: "1 dag" },
    { model: "16GB RAM oppgradering", price: "Fra 1500 kr", time: "1 dag" },
    { model: "32GB RAM oppgradering", price: "Fra 2800 kr", time: "1 dag" }
  ],
  software: [
    { model: "Windows installasjon", price: "899 kr", time: "2-3 timer" },
    { model: "macOS installasjon", price: "899 kr", time: "2-3 timer" },
    { model: "Linux installasjon", price: "799 kr", time: "2-3 timer" },
    { model: "Virusfjerning", price: "699 kr", time: "2-4 timer" },
    { model: "Dataoverføring", price: "499 kr", time: "1-2 timer" },
    { model: "PC opprydding/optimalisering", price: "599 kr", time: "2 timer" }
  ],
  other: [
    { model: "Diagnose (PC/Mac)", price: "Gratis", time: "30 Min" },
    { model: "Batteribytte (Laptop)", price: "Fra 1200 kr", time: "1 dag" },
    { model: "Vifterens og kjølingsservice", price: "Fra 699 kr", time: "2 timer" },
    { model: "Ladeport reparasjon", price: "Fra 899 kr", time: "1 dag" },
    { model: "Hovedkort reparasjon", price: "Fra 1500 kr", time: "3-5 dager" }
  ]
};
